<template>
  <el-skeleton
    :class="bem.e('skeleton')"
    :loading="loading"
    style="background: #fff; padding: 5px 15px"
    :rows="1"
  />
  <div
    ref="uniVue"
    :class="`${bem.b()} ${prepareClassNames()}`"
    :style="{
      ...prepareStyles(),
    }"
  />
</template>
<script setup lang="ts">
import { createNameSpace } from '@el-plus/utils/bem'
import { uniVueProps } from './uni-vue'
import { prepareClassNames, prepareStyles } from '@el-plus/utils/props'
import { ElSkeleton } from 'element-plus'
import { useUniVue } from './use-uni-vue'
defineOptions({
  name: 'EpUniVue',
  inheritAttrs: false,
})
const bem = createNameSpace('uni-vue')
const props = defineProps(uniVueProps)
const emit = defineEmits<{
  (e: `update:${string}`, value: any): void
}>()
const { loading } = useUniVue(props, emit)
</script>
